<!--
  ~ Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
  -->

<div class="wrapper">
  @if (hasPrefix$ | async){
    <div class="prefix">
      <ng-content select="[ngfPrefix]"></ng-content>
    </div>
  }

  <div class="infix" [class.infix-overflow-hidden]="infixOverflowHidden">
    <ng-content></ng-content>
  </div>

  @if (hasSuffix$ | async) {
    <div class="suffix">
      <ng-content select="[ngfSuffix]"></ng-content>
    </div>
  }
</div>
